<template>
<nav class="navbar fixed-top navbar-dark bg-dark">
  <a class="navbar-brand" href="#">LEEMMA</a>
</nav>
</template>

<script>
export default {
  name:'topbar',

}
</script>

<style type="scss">

</style>



// WEBPACK FOOTER //
// src/components/topbar.vue